export default function ValidationTravelerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M46.7912 15.4656V50.9688H9.20996V5.03125H36.3568L46.7912 15.4656Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M46.7912 15.4656V17.5656H34.2568V5.03125H36.3568L46.7912 15.4656Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M36.3568 25.8906L25.9006 36.3469L20.6943 31.1188" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
    </svg>
  );
}
